module.exports = __webpack_public_path__ + "static/media/chemical.151fe17a.svg";